// extracted by mini-css-extract-plugin
export default {"container":"hwQm48","content":"a626EY","left":"hkm8OD","right":"cVTUCs","open":"PQfGgM","closing":"m42Pqb"};